import { render, staticRenderFns } from "./OverallBalanceUser.vue?vue&type=template&id=68ac62b6&scoped=true&lang=pug"
import script from "./OverallBalanceUser.vue?vue&type=script&lang=ts"
export * from "./OverallBalanceUser.vue?vue&type=script&lang=ts"
import style0 from "./OverallBalanceUser.vue?vue&type=style&index=0&id=68ac62b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68ac62b6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
